<button
  [matButton]="'elevated'"
  class="crm-button"
  [class.crm-button--primary]="variant === 'primary'"
  [class.crm-button--secondary]="variant === 'secondary'"
  [class.crm-button--delete]="variant === 'delete'"
  [type]="type"
  [disabled]="disabled || isLoadingSig()"
  [attr.aria-busy]="isLoadingSig() ? 'true' : null"
  [attr.aria-label]="isLoadingSig() ? 'Loading…' : showCheck() ? 'Done' : null"
  [style.width]="wide ? '100%' : width ? width + 'px' : null"
  (click)="onClick($event)"
>
  <!-- Label remains to reserve width -->
  <div class="crm-button__label" [class.crm-button__label--hidden]="showSpinner() || showCheck()">
    <ng-content></ng-content>
    @if (suffixIcon && !(showSpinner() || showCheck())) {
      <mat-icon class="crm-suffix-icon" [svgIcon]="suffixIcon"></mat-icon>
    }
  </div>

  @if (showSpinner() || showCheck()) {
    <div class="crm-button__overlay" aria-hidden="true">
      @if (showSpinner()) {
        <mat-progress-spinner
          class="crm-button__spinner"
          mode="indeterminate"
          [diameter]="16"
          [strokeWidth]="2"
        />
      } @else {
        <mat-icon
          class="crm-button__icon crm-button__icon--done crm-button__icon--enter"
          fontSet="material-symbols-outlined"
          aria-hidden="true"
          >check</mat-icon
        >
      }
    </div>
  }
</button>
